import React, { useMemo } from "react";
import { Button as ChakraButton } from "@chakra-ui/react";
import { theme } from "src/styles/theme";

interface IButton {
  title: React.ReactNode;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  colorDisabled?: boolean;
  colorError?: boolean;
  disabled?: boolean;
  error?: boolean;
  colorInverter?: boolean;
}

const Button = ({
  onClick,
  title,
  disabled,
  colorDisabled,
  colorError,
  error,
  colorInverter,
}: IButton) => {
  const styles = useMemo(() => {
    if (colorDisabled || disabled) {
      return {
        border: "none",
        bg: theme.disable,
        color: "white",
      };
    }
    if (error) {
      return {
        border: `2px solid ${theme.error}`,
        bg: error ? "transparent" : theme.error,
        color: theme.error,
      };
    }
    if (colorError) {
      return {
        border: `2px solid ${theme.error}`,
        bg: error ? "transparent" : theme.error,
        color: "white",
      };
    }
    if (colorInverter) {
      return {
        border: `2px solid ${theme.primary}`,
        bg: "white",
        color: theme.primary,
      };
    }
    return {
      border: "none",
      bg: theme.primary,
      color: "white",
    };
  }, [colorDisabled, disabled, error, colorError, colorInverter]);

  return (
    <ChakraButton
      onClick={onClick}
      isDisabled={disabled}
      _hover={{ opacity: 1 }}
      border={styles.border}
      h="42px"
      borderRadius="8px"
      fontSize="14px"
      alignItems="center"
      justifyContent="center"
      backgroundColor={styles.bg}
      _disabled={{ bg: theme.disable }}
      color={styles.color}
      opacity={0.8}
      aria-disabled={disabled}
    >
      {title}
    </ChakraButton>
  );
};

export default Button;
